import { StyleSheet } from 'aphrodite';
import { borderColor } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	modalContainer: {
		width: 500,
		padding: 20,
	},
	loadingContainer: {
		padding: 40,
		textAlign: 'center',
	},
	section: {
		marginTop: 24,
		marginBottom: 24,
	},
	rolesList: {
		listStyle: 'none',
		padding: 0,
		margin: 0,
	},
	roleItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: 12,
		borderBottom: `1px solid ${borderColor}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	roleName: {
		fontSize: 14,
	},
	removeButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 4,
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.5,
		},
	},
	emptyMessage: {
		color: '#999',
		fontStyle: 'italic',
		fontSize: 14,
	},
	addRoleContainer: {
		display: 'flex',
		gap: 12,
		alignItems: 'center',
	},
	roleSelect: {
		flex: 1,
	},
	addButton: {},
	modalActions: {
		marginTop: 32,
		display: 'flex',
		gap: 16,
		justifyContent: 'flex-end',
	},
});
